import { DatePicker, DatePickerProps } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { observer } from 'mobx-react-lite'

dayjs.extend(localizedFormat)
export interface Props {
  startDate?: Date | null
  endDate?: Date | null
  dataCy?: string
  allowClear?: boolean
  sx?: React.CSSProperties
  onDateChange: (startDate?: Date, endDate?: Date) => void
}
export const DateRangePicker = observer((props: Props) => {
  const { startDate, endDate, sx, dataCy, allowClear = false, onDateChange } = props
  const { RangePicker } = DatePicker
  type RangeValue = [from: Dayjs | null, to: Dayjs | null] | null

  const handleDateChange = (val: RangeValue) => {
    onDateChange(val?.[0]?.toDate(), val?.[1]?.toDate())
  }

  const value: RangeValue = startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : [null, null]

  return (
    <RangePicker
      style={sx}
      value={value}
      onChange={handleDateChange}
      data-cy={dataCy ?? 'date-picker-field'}
      disabledDate={disabled60DaysDate}
      format={dayjs.Ls[dayjs.locale()].formats.L}
      allowClear={allowClear}
      getPopupContainer={(triggerNode: HTMLElement) => triggerNode.parentNode as HTMLElement}
    />
  )
})

const getYearMonth = (date: Dayjs) => date.year() * 12 + date.month()
const disabled60DaysDate: DatePickerProps['disabledDate'] = (current, { from, type }) => {
  if (from) {
    const minDate = from.add(-6, 'days')
    const maxDate = from.add(6, 'days')

    switch (type) {
      case 'year':
        return current.year() < minDate.year() || current.year() > maxDate.year()

      case 'month':
        return (
          getYearMonth(current) < getYearMonth(minDate) ||
          getYearMonth(current) > getYearMonth(maxDate)
        )

      default:
        return Math.abs(current.diff(from, 'days')) >= 90
    }
  }

  return false
}
